/**
 * eip模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const eip = {
    //分页查询弹性IP接口
    pageEip(params) {
        return $http.post(`${global.API_URL}/sme/eip/page`,params);
      },
    //删除
    deleteEip(id ,params) {
      let param = new URLSearchParams();
      param.append(id, params);
      return $http.post(`${global.API_URL}/sme/eip/delete`,param);
    },
      //弹性ip详情
  queryEipByAllocationId(params) {
    return $http.post(`${global.API_URL}/sme/eip/queryEipByAllocationId`,params);
  }
 }
 
 export default eip;
 


// WEBPACK FOOTER //
// ./src/api/eip.js